/* global jQuery, _WhiskZoomCustomizerReset, ajaxurl, wp */

jQuery(function ($) {
    var $container = $('#customize-header-actions');


    var $button = $('<input type="submit" name="whisk-zoom-reset" id="whisk-zoom-reset" class="button-secondary button">')
        .attr( 'value', _WhiskZoomCustomizerReset.reset )
        .css({
            'float': 'right',
            'margin-right': '10px',
            'margin-top': '9px'
        });

    $button.on( 'click', function ( event ) {
        event.preventDefault();

        var data = {
            wp_customize: 'on',
            action: 'whisk_customizer_reset',
            nonce: _WhiskZoomCustomizerReset.nonce.reset
        };

        var r = confirm( _WhiskZoomCustomizerReset.confirm );

        if (!r) return;

        $button.attr( 'disabled', 'disabled' );

        $.post(ajaxurl, data, function () {
            wp.customize.state('saved').set(true);
            location.reload();
        });
    });

    $container.append( $button );
});
